import { useHistory } from 'react-router'
import { FlexBox } from 'shared/components/Base/FlexBox'
import { Box } from 'shared/components/Box/Box'
import { Button } from 'shared/components/Button/Button'
import { Text } from 'shared/components/Text/Text'
import { error, warning } from 'shared/theme/colors'
import styled, { css } from 'styled-components'

import { AutoApproveFailureReason } from 'helpers/constants'
import { AutoApprovalFailureFlagType, Job, ReviewForApprovalResponse } from 'models/jobs'
import ErrorIcon from '../../assets/images/ErrorIcon36.svg'
import WarningIcon from '../../assets/images/WarningIcon36.svg'

interface AutoApprovalFailureFlagsProps {
  reviewForApprovalResponse: ReviewForApprovalResponse
  job: Job
}

const StyledFailureFlag = styled(FlexBox)<{ $backgroundColor: string }>`
  gap: 14px;
  padding: 12px;
  padding-left: 80px;
  border-radius: 6px;
  align-items: center;
  ${({ $backgroundColor }) => css`
    background-color: ${$backgroundColor};
  `}
`

const StyledButton = styled(Button)`
  margin-left: auto;
  margin-right: 80px;
`

const AutoApprovalFailureFlags = ({ reviewForApprovalResponse, job }: AutoApprovalFailureFlagsProps) => {
  const history = useHistory()
  const rateConUrl = reviewForApprovalResponse.rate_confirmation?.attachments[0]?.file
  return (
    <FlexBox isColumn gap="2px" minWidth="1000px">
      <Text variant="paragraph1" fontWeight={600}>
        Couldn't auto-approve due to issues found on{' '}
        <a href={rateConUrl} target="_blank" rel="noreferrer">
          rate con
        </a>
      </Text>
      {reviewForApprovalResponse.auto_approval_failure_flags?.map((flag, index) => (
        <StyledFailureFlag
          gap="14px"
          $backgroundColor={flag.type === AutoApprovalFailureFlagType.Error ? error : warning}
          key={index}
        >
          <img src={flag.type === AutoApprovalFailureFlagType.Error ? ErrorIcon : WarningIcon} alt="" />
          <Box key={index}>
            <Text fontWeight={600} variant="paragraph1">
              {flag.title}
            </Text>
            {flag.description && <Text variant="paragraph1">{flag.description}</Text>}
          </Box>
          {flag.check === AutoApproveFailureReason.FEASIBILITY && reviewForApprovalResponse.schedule_id && (
            <StyledButton
              variant="secondary"
              size="small"
              onClick={() =>
                history.push({
                  pathname: `/jobs/${job.id}/schedules/${reviewForApprovalResponse.schedule_id}/inspect`,
                  state: {
                    title: flag.title,
                  },
                })
              }
            >
              VIEW DETAILS
            </StyledButton>
          )}
          {flag.check === AutoApproveFailureReason.BROKER_AT_RISK && job?.load?.broker && (
            <StyledButton
              variant="secondary"
              size="small"
              onClick={() => history.push(`/brokers/${job.load.broker.id}/show`)}
            >
              VIEW BROKER
            </StyledButton>
          )}
        </StyledFailureFlag>
      ))}
    </FlexBox>
  )
}

export default AutoApprovalFailureFlags
